var transactionFilters = jq('#transaction-filters');
if (transactionFilters.length) {
    
    // Get params for transactions
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };
    
    var role = getUrlParameter('role');
    var sector = getUrlParameter('sector');
    if (role) {
        jq('option[value="' + escape(role) + '"]', '#transaction-role').attr('selected', 'selected');
    }
    if (sector) {
        jq('option[value="' + escape(sector) + '"]', '#transaction-sector').attr('selected', 'selected');
    }
    // Change function for transaction select filters
    jq('select', '#transaction-filters').change(function() {
        var queryString = '?';
        jq('select', '#transaction-filters').each(function() {
            var val = jq(this).val();
            if (val && val != '-1') {
                if (queryString != '?') {
                    queryString += '&';    
                }
                queryString += jq(this).attr('name') + '=' + val;
            }
        });
        if (queryString == '?') {
            window.location.href = '/transactions';    
        } else {
            window.location.href = '/transactions' + queryString;    
        }
        return;
    });
}

var teamFilters = jq('#team-filters');
if (teamFilters.length) {
    // Get params for transactions
    var getUrlParameter = function getUrlParameter(sParam) {
        var sPageURL = window.location.search.substring(1),
            sURLVariables = sPageURL.split('&'),
            sParameterName,
            i;
    
        for (i = 0; i < sURLVariables.length; i++) {
            sParameterName = sURLVariables[i].split('=');
    
            if (sParameterName[0] === sParam) {
                return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
            }
        }
    };
    
    var capability = getUrlParameter('capability');
    if (capability) {
        jq('option[value="' + escape(capability) + '"]', '#capability').attr('selected', 'selected');
        jq('.team-box').each(function() {
            var memberCapability = jq(this).data('capability');
            if (memberCapability.includes(capability)) {
                jq(this).parent().removeClass('hide');    
            } else {
                jq(this).parent().addClass('hide');    
            }
        });
    }
    jq('#capability').change(function(){
        var val = jq(this).val();   
        console.log(val);
        if (!val || val == -1) {
            jq('.team-box').parent().removeClass('hide');
            return;
        }
        jq('.team-box').each(function() {
            var memberCapability = jq(this).data('capability');
            if (memberCapability.includes(val)) {
                jq(this).parent().removeClass('hide');    
            } else {
                jq(this).parent().addClass('hide');    
            }
        });
        return;
    });
}

// EVENTS
var currentDate = new Date(), // Get the current date
    currentMonth = currentDate.getMonth(), // Set current month
    currentYear = currentDate.getFullYear(); // Set current year
var $dayList = jq('.days');

var monthMap = [
  'JANUARY',
  'FEBRUARY',
  'MARCH',
  'APRIL',
  'MAY',
  'JUNE',
  'JULY',
  'AUGUST',
  'SEPTEMBER',
  'OCTOBER',
  'NOVEMBER',
  'DECEMBER',
];

var addDayElement = function (date, $container) {
  var element = jq(document.createElement('div')).addClass('date');

  if (date.getMonth() !== currentMonth) {
    element.addClass('out-of-scope');
  }
  
  // Format the date to 'month-day-year'
  var formattedDate = date.toLocaleString('default', { month: 'short' }).toLowerCase() + '-' + date.getDate() + '-' + date.getFullYear();
  
  // Add the formatted date as a class
  element.attr('data-date', formattedDate);
  element.text(date.getDate());  
  // Check if this is today's date and add 'today' class if true
  if (
    date.getDate() === currentDate.getDate() &&
    date.getMonth() === currentDate.getMonth() &&
    date.getFullYear() === currentDate.getFullYear()
  ) {
    element.addClass('today');
  }  
  $container.append(element);
  // Ensure to clear the content of out-of-scope elements
  jq('.out-of-scope').empty();
  
  getActiveEvents();
};

var getActiveEvents = function (date) {    
    observeForContent('#events-data').then(() => {
        var eventsData = jq('#events-data').text();
        var events = JSON.parse(eventsData).events;
        
        jq.each(events, function (index, event) {
            var dateClass = event.dateClass.toLowerCase();
            
            // Find the .date element with matching data-date attribute
            jq('.date[data-date="' + dateClass + '"]').addClass('has-event').attr('tabindex', '0').attr('role', 'button');
        });         
    });   
};

var getFirstLastDates = function (date) {
  var startDate, endDate;
  startDate = new Date(date.getFullYear(), date.getMonth(), 1);
  while (startDate.getDay() !== 1) {
    startDate.setDate(startDate.getDate() - 1);
  }
  endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);
  while (endDate.getDay() !== 0) {
    endDate.setDate(endDate.getDate() + 1);
  }
  return [startDate, endDate];
};

var renderDays = function (dateRange) {
  $dayList.empty();
  var startDate = dateRange[0],
    endDate = dateRange[1],
    tempDate = new Date(startDate);
  while (tempDate <= endDate) {
    addDayElement(new Date(tempDate), $dayList);
    tempDate.setDate(tempDate.getDate() + 1);
  }
};

var loadCalendar = function (date) {
  jq('.headline .month').text(monthMap[currentMonth]);
  jq('.headline .year').text(currentYear);
  renderDays(getFirstLastDates(date));
};

loadCalendar(new Date(currentYear, currentMonth));

jq('.click-left').on('click', function () {
  currentMonth--;
  if (currentMonth < 0) {
    currentMonth = 11;
    currentYear--;
  }
  loadCalendar(new Date(currentYear, currentMonth));
});

jq('.click-right').on('click', function () {
  currentMonth++;
  if (currentMonth > 11) {
    currentMonth = 0;
    currentYear++;
  }
  loadCalendar(new Date(currentYear, currentMonth));
});

jq('.prev-year').on('click', function () {
  currentYear--;
  if (currentYear < 0) {
    currentYear = 11;
    currentYear--;
  }
  loadCalendar(new Date(currentYear, currentMonth));
});

jq('.next-year').on('click', function () {
  currentYear++;
  if (currentMonth > 11) {
    currentYear = 0;
    currentYear++;
  }
  loadCalendar(new Date(currentYear, currentMonth));
});

// Function to handle date selection and show events
let handleDateSelection = function (element) {
    if (element.hasClass('has-event')) {
        let activeDate = element.attr('data-date');
        jq('.date').removeClass('selected');
        element.addClass('selected');
        showDateEvents(activeDate);
        jq('.show-all').fadeIn();
    }
};

// Ensure date selection is only applied to dates within the current month
jq('.days').on('click', '.date:not(.out-of-scope)', function () {
    handleDateSelection(jq(this));
});

// Handle keyboard navigation and Enter key press
jq('.days').on('keydown', '.date:not(.out-of-scope)', function (event) {
    if (event.key === 'Enter' || event.keyCode === 13) {
        handleDateSelection(jq(this));
    }
});
jq('.show-all').on('click', function() {
    jq('.module-events:not(.module-nd-events) .event-box').css('display', 'grid').addClass('active');
    jq('.events-slider-wrapper').css('display', 'block').addClass('active');
    jq('.show-all').fadeOut();
    jq('.date').removeClass('selected');
});
let showDateEvents = function(date) {
    // Hide all event boxes and remove the 'active' class
    jq('.module-events:not(.module-nd-events) .event-box').fadeOut().removeClass('active');
    
    jq('.events-slider-wrapper').fadeOut().removeClass('active');
    
    // Show and activate the event boxes that match the selected date
    jq('.module-events:not(.module-nd-events) .event-box').each(function() {
        if (jq(this).attr('data-date') == date) {
            jq(this).addClass('active').fadeIn();
            jq(this).parent().parent().addClass('active').fadeIn();
        }
    });
    
    jq('.events-slider-wrapper .event-box').each(function() {
        if (jq(this).attr('data-date') == date) {
            jq(this).parent().parent().addClass('active').fadeIn();
        }
    });
}

function observeForContent(selector) {
    return new Promise((resolve, reject) => {
        let checkInterval = setInterval(() => {
            if (jq(selector).html()) {
                clearInterval(checkInterval);
                resolve();
            }
        }, 100); // Check every 100 milliseconds
    });
}
//Start UserSnap
window.onUsersnapLoad = function(api) {
    api.init();
}
var script = document.createElement('script');
script.defer = 1;
script.src = 'https://widget.usersnap.com/global/load/898ce5e0-af27-4c23-9f78-6da97e4baa61?onload=onUsersnapLoad';
document.getElementsByTagName('head')[0].appendChild(script);
//End UserSnap

jq(document).ready(function() {
    // Custom Events Slider
    // Non-Deal Roadshow Events
    const gridWrappers = jq('.events-slider-wrapper');

    gridWrappers.each(function() {
        const wrapper = jq(this);
        const container = wrapper.find('.event-row');
        const items = container.find('.grid-item:not(.sticky)');
        const prevButton = wrapper.find('.slider-prev');
        const nextButton = wrapper.find('.slider-next');

        let startIndex = 0;
        const defaultVisibleItemsCount = 3; // Number of visible columns excluding the sticky one

        function updateVisibleItems() {
            if (window.innerWidth <= 991) {
                // Show all items on smaller screens
                items.show();
                prevButton.hide();
                nextButton.hide();
            } else {
                // Enable slider on larger screens
                const visibleItemsCount = defaultVisibleItemsCount;
                items.each(function(index) {
                    if (index >= startIndex && index < startIndex + visibleItemsCount) {
                        jq(this).show();
                    } else {
                        jq(this).hide();
                    }
                });
                prevButton.show();
                nextButton.show();
            }
        }

        if (prevButton.length) {
            prevButton.on('click', function() {
                if (startIndex > 0) {
                    startIndex -= 1;
                    updateVisibleItems();
                }
            });
        }

        if (nextButton.length) {
            nextButton.on('click', function() {
                if (startIndex + defaultVisibleItemsCount < items.length) {
                    startIndex += 1;
                    updateVisibleItems();
                }
            });
        }

        // Initial call to set the visible items
        updateVisibleItems();

        // Adjust visible items on window resize
        jq(window).on('resize', function() {
            updateVisibleItems();
        });
    });
});